<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Regras de Pagamento - {{pagamento.codPagamento != null ? 'Editar' : 'Incluir'}}</h1>
        <b-card>
            <b-row class="mb-0">
                <b-col sm="12" md="3" class="mb-0">
                    <b-form-group
                            label="Receita:"
                            label-for="valor"
                            class="text-label required">
                          
                        <b-form-select v-model="pagamento.receita" @change="acaoDaAlteracaoDaReceita()"
                            :class="'text-label required ' + (!paymentValidations.receita.valid ? 'is-invalid' : '')">
                            <option
                                    v-for="tc in dados.receitas"
                                    :key="tc.id"
                                    :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                        <div v-if="!paymentValidations.receita.valid" class="invalid-message">{{paymentValidations.receita.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3" class="mt-3">
                    <label></label>
                    <b-form-group id="input-group" label label-for="refiz" v-if="validarRegraHabilitar([0, 1, 2, 3, 4, 5])">
                        <b-form-checkbox v-model="pagamento.refiz" id="refiz" name="check-button" switch>
                            Refis
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group id="input-delibSid" label label-for="delibSid">
                        <b-form-checkbox v-model="pagamento.delibSid" id="delibSid" name="check-button" switch>
                            Campo Nº Deliberação Conselho e SID
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="2" md="5">
                    <b-form-group
                            label="Nome:"
                            label-for="nome"
                            class="text-label required">
                        <b-form-input v-model="pagamento.descricao" type="text" id="nome" maxlength="250" 
                            :class="'text-label required ' + (!paymentValidations.descricao.valid ? 'is-invalid' : '')"/>
                            <div v-if="!paymentValidations.descricao.valid" class="invalid-message">{{paymentValidations.descricao.message}}</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="2">
                    <p class="mb-0">
                        <b>Vigência:</b>
                    </p>
                    <label for="dataInicial">
                        Data Inicial:
                        <span class="text-danger">*</span>
                    </label>
                    <b-input v-model="pagamento.dataInicialVigencia" id="dataInicial" type="date" placeholder @blur="validarData(pagamento.dataInicialVigencia, 'Inicial', paymentValidations.dataInicialVigencia)"
                        :class="'text-label required ' + (!paymentValidations.dataInicialVigencia.valid ? 'is-invalid' : '')">
                    </b-input>
                    <div v-if="!paymentValidations.dataInicialVigencia.valid" class="invalid-message">{{paymentValidations.dataInicialVigencia.message}}</div>
                </b-col>
                <b-col sm="12" md="2">
                    <p class="mb-0">&nbsp;</p>
                    <label for="dataFinal">
                        Data Final:
                        <span class="text-danger">*</span>
                    </label>
                    <b-input v-model="pagamento.dataFinalVigencia" id="dataFinal" type="date" placeholder @blur="validarData(pagamento.dataFinalVigencia, 'Final', paymentValidations.dataFinalVigencia)"
                        :class="'text-label required ' + (!paymentValidations.dataFinalVigencia.valid ? 'is-invalid' : '')">
                    </b-input>
                    <div v-if="!paymentValidations.dataFinalVigencia.valid" class="invalid-message">{{paymentValidations.dataFinalVigencia.message}}</div>
                </b-col>
                <b-col sm="12" md="8"  v-if="validarRegraHabilitar([0, 1, 2, 3, 4, 5])">
                    <p class="mb-0">&nbsp;</p>
                    <p>
                        Base de cálculo:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-9"
                                v-model="pagamento.baseCalculo"
                                name="radio-baseCalculo">
                            <b-form-radio value="0">Valor Hist. do Aju/Pro atualizado</b-form-radio>
                            <b-form-radio value="1">Valor Pendente no FIR</b-form-radio>
                            <b-form-radio value="2" v-if="validarRegraHabilitar([1, 2, 4, 5, 6])">Valor Hist. do Aju/Pro atualizado c/ deduções REFIS</b-form-radio>
                            <b-form-radio value="3" v-if="validarRegraHabilitar([1, 2, 4, 5, 6])">Valor Pendente c/ deduções REFIS</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Valor Mínimo da Parcela (R$):"
                            label-for="valorminparc"
                            class="text-label required">
                        <b-form-input v-model="pagamento.valorMinimoParcela" type="text" id="valorminparc"
                                      :class="!paymentValidations.valorMinimoParcela.valid ? 'is-invalid' : ''"
                                      @keyup="pagamento.valorMinimoParcela = formatarMonetario(pagamento.valorMinimoParcela)"></b-form-input>
                        <div v-if="!paymentValidations.valorMinimoParcela.valid" class="invalid-message">{{paymentValidations.valorMinimoParcela.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Percentual Pré-fixado de Honorários:"
                            label-for="valorprefix"
                            :class="(validarRegraHabilitar([0, 1, 2]) ? 'required' : '' + 'text-label')">
                        <b-form-input v-model="pagamento.percentualHonorario" type="text" id="valorprefix"
                                      :class="!paymentValidations.percentualHonorario.valid ? 'is-invalid' : ''"
                                      @keyup="pagamento.percentualHonorario = formatarDecimalPositivo(pagamento.percentualHonorario, 3, 2)"
                        />
                        <div v-if="!paymentValidations.percentualHonorario.valid" class="invalid-message">{{paymentValidations.percentualHonorario.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Índice de Reajuste a sugerir:"
                            label-for="valorindica"
                            class="text-label" >
                        <b-form-select v-model="pagamento.indice" class="mb-3">
                            <template v-slot:first>
                                <option :value="null">Selecionar</option>
                            </template>
                            <option
                                    v-for="tc in dados.indices"
                                    :key="tc.id"
                                    :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Número de Parcelas Atrasadas:"
                            label-for="numeroParcelasRescisao"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                id="numeroParcelasRescisao"
                                v-model="pagamento.numeroParcelasRescisao"
                                :class="'text-label required ' + (!paymentValidations.numeroParcelasRescisao.valid ? 'is-invalid' : '')"
                                v-mask="['####']">
                        </b-form-input>
                        <div v-if="!paymentValidations.numeroParcelasRescisao.valid" class="invalid-message">{{paymentValidations.numeroParcelasRescisao.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Número de Dias de Atraso:"
                            label-for="numeroDiasAtrasoParcela"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                id="numeroDiasAtrasoParcela"
                                v-model="pagamento.numeroDiasAtrasoParcela"
                                :class="!paymentValidations.numeroDiasAtrasoParcela.valid ? 'is-invalid' : ''"
                                v-mask="['####']">
                        </b-form-input>
                        <div v-if="!paymentValidations.numeroDiasAtrasoParcela.valid" class="invalid-message">{{paymentValidations.numeroDiasAtrasoParcela.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <p>
                        Situação:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-9"
                                v-model="pagamento.indAtivo"
                                name="radio-situacao" >
                            <b-form-radio value="true">Ativo</b-form-radio>
                            <b-form-radio value="false">Inativo</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <p>
                        Titular da Receita:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-10"
                                v-model="pagamento.titularReceita"
                                name="radio-titularReceita" >
                            <b-form-radio value="0">FEPGE</b-form-radio>
                            <b-form-radio value="1">CES</b-form-radio>
                            <b-form-radio value="2">Ambos</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>                
            </b-row>
        </b-card>
        <b-card title="Configuração - Faixas de Pagamento" sub-title="(toda Regra de Pagamento deverá possuir ao menos uma faixa de pagamento)">
            <b-row>
                <b-col sm="2" md="3">
                    <b-form-group
                            label="Descrição:"
                            label-for="descricao"
                            class="text-label required">
                        <b-form-input v-model="tipoPagamento.descricao" maxlength="50" type="text" id="descricao"
                            :class="'text-label required ' + (!paymentRangeValidations.descricao.valid ? 'is-invalid' : '')">
                        </b-form-input>
                        <div v-if="!paymentRangeValidations.descricao.valid" class="invalid-message">{{paymentRangeValidations.descricao.message}}</div>

                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Tipo de Pagamento:"
                            label-for="tipocred"
                            class="text-label required">
                        <b-form-select v-model="tipoPagamento.tipoPagamento" @change="alterarTipoPagamento()"
                            :class="'text-label required ' + (!paymentRangeValidations.tipoPagamento.valid ? 'is-invalid' : '')">
                            <template v-slot:first>
                                <option :value="null">Selecionar</option>
                            </template>
                            <option
                                    v-for="tc in dados.tiposPagamento"
                                    :key="tc.id"
                                    :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                        <div v-if="!paymentRangeValidations.tipoPagamento.valid" class="invalid-message">{{paymentRangeValidations.tipoPagamento.message}}</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Nº Mínimo de Parcelas:"
                            label-for="minimo"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="minimo"
                                v-model="tipoPagamento.numeroMinimoParcelas"
                                v-mask="['#####']"
                                :disabled="tipoPagamento.tipoPagamento != null && tipoPagamento.tipoPagamento.id == 0"
                                :class="!validations.parcelas.valid || !validations.numeroMinimoParcelas.valid ? 'is-invalid' : ''"/>
                    </b-form-group>
                    <div v-if="!validations.numeroMinimoParcelas.valid" class="invalid-message">O Nº Mínimo de Parcelas deve ser maior que 0!</div>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Nº Máximo de Parcelas:"
                            label-for="maximo"
                            class="text-label">
                        <b-form-input
                                type="text"
                                id="maximo"
                                v-model="tipoPagamento.numeroMaximoParcelas"
                                v-mask="['#####']"
                                :disabled="tipoPagamento.tipoPagamento != null && tipoPagamento.tipoPagamento.id == 0"
                                :class="!validations.parcelas.valid || !validations.numeroMaximoParcelas.valid ? 'is-invalid' : ''"/>
                    </b-form-group>
                    <div v-if="!validations.numeroMaximoParcelas.valid" class="invalid-message">O No Máximo de Parcelas deve ser maior que 0!</div>
                </b-col>
            </b-row>
            <b-row v-if="!validations.parcelas.valid" style="color: red; margin-top: -15px;">
                <b-col sm="12" md="3">
                </b-col>
                <b-col sm="12" md="3">
                </b-col>
                <b-col sm="12" md="5" >
                    <div v-if="!validations.parcelas.valid" class="invalid-message">O nº mínimo de parcelas deve ser menor ou igual ao nº máximo de parcelas!</div>
                </b-col>
            </b-row>
            <b-row v-if="validarRegraHabilitar([0, 1, 2, 3, 4, 5])">
                <b-col sm="12" md="4">
                    <div>
                        <label class="typo__label">
                            Tipo de Crédito:
                        </label>
                        <multiselect
                                v-model="tipoPagamento.tiposCredito"
                                tag-placeholder
                                placeholder="Selecionar uma ou mais opções"
                                label="nome"
                                track-by="id"
                                :options="dados.tiposCredito"
                                :multiple="true"
                                :taggable="true">
                        </multiselect>
                    </div>
                </b-col>
                <b-col sm="12" md="2" v-if="validarRegraHabilitar([2, 5, 6])">
                    <b-form-group
                            label="% Desc Principal:"
                            label-for="percdescprincipal"
                            class="text-label">
                        <b-form-input v-model="tipoPagamento.percentualPrincipal" type="text" id="percdescprincipal"
                                      @keyup="tipoPagamento.percentualPrincipal = formatarDecimalPositivo(tipoPagamento.percentualPrincipal, 3, 2)"
                                      :class="!validations.percentualPrincipal.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.percentualPrincipal.valid" class="invalid-message">O % Desc Principal deve ser maior que 0!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="validarRegraHabilitar([2, 5, 6])">
                    <b-form-group
                            label="% Desc Multa:"
                            label-for="percdescmulta"
                            class="text-label">
                        <b-form-input v-model="tipoPagamento.percentualDescontoMulta" type="text" id="percdescmulta"
                                      @keyup="tipoPagamento.percentualDescontoMulta = formatarDecimalPositivo(tipoPagamento.percentualDescontoMulta, 3, 2)"
                                      :class="!validations.percentualDescontoMulta.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.percentualDescontoMulta.valid" class="invalid-message">O % Desc Multa deve ser maior que 0!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2" v-if="validarRegraHabilitar([2, 5, 6])">
                    <b-form-group
                        label="% Desc Juros:"
                        label-for="percdescjuros"
                        class="text-label">
                        <b-form-input v-model="tipoPagamento.percentualDescontoJuros" type="text" id="percdescjuros"
                                      @keyup="tipoPagamento.percentualDescontoJuros = formatarDecimalPositivo(tipoPagamento.percentualDescontoJuros, 3, 2)"
                                      :class="!validations.percentualDescontoJuros.valid ? 'is-invalid' : ''"/>
                        <div v-if="!validations.percentualDescontoJuros.valid" class="invalid-message">O % Desc Juros deve ser maior que 0!</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Valor Mínimo de Honorários:"
                            label-for="valorMinimoHonorario"
                            class="text-label">
                        <b-form-input v-model="tipoPagamento.valorMinimoHonorario" type="text" id="valorMinimoHonorario"
                                      :disabled="tipoPagamento.tipoPagamento != null && tipoPagamento.tipoPagamento.id == 0"
                                      :class="!validations.valores.valid || !validations.valorMinimoHonorario.valid ? 'is-invalid' : ''"
                                      @keyup="tipoPagamento.valorMinimoHonorario = formatarMonetario(tipoPagamento.valorMinimoHonorario)"></b-form-input>
                        <div v-if="!validations.valorMinimoHonorario.valid" class="invalid-message">O Valor Mínimo de Honorários deve ser maior que 0!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Valor Máximo de Honorários:"
                            label-for="valorMaximoHonorario"
                            class="text-label">
                        <b-form-input v-model="tipoPagamento.valorMaximoHonorario" type="text" id="valorMaximoHonorario"
                                      :disabled="tipoPagamento.tipoPagamento != null && tipoPagamento.tipoPagamento.id == 0"
                                      :class="!validations.valores.valid || !validations.valorMaximoHonorario.valid ? 'is-invalid' : ''"
                                      @keyup="tipoPagamento.valorMaximoHonorario = formatarMonetario(tipoPagamento.valorMaximoHonorario)"></b-form-input>
                        <div v-if="!validations.valorMaximoHonorario.valid" class="invalid-message">O Valor Máximo de Honorários deve ser maior que 0!</div>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <p>
                        Situação Cadastro:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-9"
                                v-model="tipoPagamento.indAtivo"
                                name="radio-situacao-tipoPagamento">
                            <b-form-radio value="true">Ativo</b-form-radio>
                            <b-form-radio value="false">Inativo</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-button
                            variant="outline-success"
                            class="mt-4" @click="adicionarTipoPagamento">
                        <i class="fa fa-plus"></i> Adicionar
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-if="!validations.valores.valid" style="color: red;">
                <b-col sm="12" md="7" >
                    <div v-if="!validations.valores.valid" class="invalid-message">O valor mínimo do honorário deve ser menor ou igual ao n° máximo de honorário!</div>
                </b-col>
            </b-row>
            <b-row md="2" class="mb-3" style="margin-top: 10px;">
                <b-col sm="12" md="3">
                    <b-button
                            variant="outline-secondary"
                            class="ml-2" @click="pesquisar">
                        <i class="fa fa-search"></i> Pesquisar
                    </b-button>
                    <b-button :disabled="selectedsTipoPagamento.length != 1"
                            variant="outline-secondary"
                            class="ml-2" @click="alterar">
                        <i class="fa fa-pen"></i> Editar
                    </b-button>
                    <b-button :disabled="selectedsTipoPagamento.length != 1"
                            variant="outline-secondary"
                            class="ml-2" @click="excluir">
                        <i class="fa fa-times"></i> Excluir
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="currentPageTipoPagamento" per-page="5" :total-rows="listaTipoPagamento.length" size="sm" class="pl-3" style="padding: 0 !important;" aria-controls="tiposPagamento">
                    </b-pagination>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
            <b-table
                    id="tiposPagamento"
                    ref="tableTipoPagamento"
                    :items="listaTipoPagamento"
                    :fields="fieldsTipoPagamento"
                    per-page="5"
                    :current-page="currentPageTipoPagamento"
                    striped
                    :class="'text-label required ' + (!paymentRangeValidations.listaTipoPagamento.valid ? 'is-invalid' : '')"
                    small
                    responsive
                    :busy="false"
                    show-empty
                    hover
                    bordered
                    sort-icon-left
                    class="mb-0"
                    head-variant="light">
                    <div slot="table-busy" class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Carregando...</strong>
                    </div>
                    <template slot="empty">
                        <p v-if="paymentRangeValidations.listaTipoPagamento.valid" class="my-auto">Nenhum tipo de pagamento encontrado.</p>
                        <p v-if="!paymentRangeValidations.listaTipoPagamento.valid" class="invalid-message">{{paymentRangeValidations.listaTipoPagamento.message}}</p>
                    </template>
                    <template v-slot:head(selecionar)="{ item }">
                        <p></p>
                    </template>
                    <template v-slot:cell(selecionar)="{ item }">
                        <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selectedsTipoPagamento.includes(item)" @change="toggleCheck($event, item)" />
                    </template>
                    <template v-slot:cell(tipoPagamento)="{ item }">
                        {{ item.tipoPagamento != null ? item.tipoPagamento.nome : "" }}
                    </template>
                    <template v-slot:cell(tiposCredito)="{ item }">
                        <p v-for="tipoCredito in item.tiposCredito" :key="tipoCredito.id">
                            {{ tipoCredito.nome }}
                        </p>
                    </template>
            </b-table>
        </b-card>
        <b-card title="CDA" v-if="pagamento.refiz">
            <b-row class="mb-2 mt-0">
                <b-col>
                    <b-form-group
                            label="Carregar Arquivo tipo CSV:"
                            label-for="numcda"
                            class="text-label required">
                        <file-upload
                                ref="upload"
                                :multiple="false"
                                :maximum="1"
                                extensions="csv"
                                v-model="arquivo"
                                @input-file="uploadFile">
                            <b-button
                                    variant="outline-info"
                                    class="mt-0">
                                <i class="fas fa-upload"></i> Carregar
                            </b-button>
                        </file-upload>
                        <div v-if="!cdaValidations.arquivo.valid" class="invalid-message">{{cdaValidations.arquivo.message}}</div>
                        {{this.pagamento.arquivo != null ? this.pagamento.arquivo.nomeArquivo : ""}}
                    </b-form-group>
                </b-col>
            </b-row>
            <br>
            <b-row class="mb-0" >
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Número CDA:"
                            label-for="numcda"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                id="numcda"
                                v-model="cda.numeroCda"
                                v-mask="['##########']"
                                :class="'text-label required ' + (!cdaValidations.numeroCda.valid ? 'is-invalid' : '')"/>
                                <div v-if="!cdaValidations.numeroCda.valid" class="invalid-message">{{cdaValidations.numeroCda.message}}
                                </div>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="2" style="position: relative;">
                    <b-button variant="outline-success" @click="adicionarCda" style="position: absolute; left: 5px; transform:translateY(60%);">
                        <i class="fa fa-plus-circle"></i>
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row md="12" class="mb-3">
                <b-col sm="12" md="12">
                    <b-button @click="pesquisarCda"
                            variant="outline-secondary"
                            class="ml-2">
                        <i class="fa fa-search"></i> Pesquisar
                    </b-button>
                    <b-button :disabled="selectedsCda.length != 1"
                            variant="outline-secondary"
                            class="ml-2" @click="excluirCda">
                        <i class="fa fa-times"></i> Excluir
                    </b-button>
                    <b-button v-if="pagamento.codPagamento != null"
                            v-b-modal.modal-busca-cda
                            variant="outline-secondary"
                            class="ml-2" @click="abrirModalCdas()">
                        <i class="fa fa-search"></i> CDA's já carregadas
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="currentPageCda" per-page="5" :total-rows="listaCdas.length" size="sm" class="pl-3" style="padding: 0 !important;" aria-controls="tableCda">
                    </b-pagination>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
            <b-table
                    id="tableCda"
                    ref="tableCda"
                    :items="listaCdas"
                    :fields="fieldsCda"
                    per-page="5"
                    :current-page="currentPageCda"
                    striped
                    small
                    responsive
                    :busy="false"
                    show-empty
                    hover
                    bordered
                    sort-icon-left
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhuma CDA encontrada.</p>
                </template>
                <template v-slot:head(selecionar)="{ item }">
                    <p></p>
                </template>
                <template v-slot:cell(selecionar)="{ item }">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selectedsCda.includes(item)" @change="toggleCheckCda($event, item)" />
                </template>
                <template v-slot:cell(situacaoDivida)="{ item }">
                     {{ item.situacaoDivida != null ? item.situacaoDivida.nome : "" }}
                </template>
                <template v-slot:cell(status)="{ item }">
                  {{ item.statusCredito != null ? item.statusCredito.nome : "" }}
                </template>
                <template v-slot:cell(tipoCredito)="{ item }">
                   {{ item.tipoCredito != null ? item.tipoCredito.nome : "" }}
                </template>
                <template v-slot:cell(indAtivo)="{ item }">
                    {{ (item.indAtivo == "true" || item.indAtivo == true) ? "Ativo" : "Inativo" }}
                </template>
            </b-table>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="pagamento.codPagamento != null">Deseja retornar à tela anterior sem salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="pagamento.codPagamento == null">Deseja retornar à tela anterior sem salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="pagamento.codPagamento != null">Deseja salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="pagamento.codPagamento == null">Deseja salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-upload"
                id="modal-upload"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cadastro em lote com erro"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">O cadastro em lote não pode ser incluido, foram verificados erros no arquivo, por favor, reveja o arquivo e tente novamente.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-upload')"> Ok</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-upload-sucesso"
                id="modal-upload-sucesso"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cadastro em lote"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">O arquivo escolhido é valido e será processado em segundo plano, após a ação do botão "Salvar".</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-upload-sucesso')"> Ok</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-busca-cda"
                id="modal-busca-cda"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="'CDA\'s carregadas para ' + (this.pagamento.descricao != null ? this.pagamento.descricao : '')"
                header-bg-variant="info"
                header-text-variant="white">
            <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant" dismissible><i class="fas fa-check-circle"></i> {{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-row class="d-flex justify-content-between">
                        <b-col>
                        </b-col>
                        <b-col style="display: flex; justify-content: center;">
                            <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" aria-controls="tableCdaModal"
                                          :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;">
                            </b-pagination>
                        </b-col>
                        <b-col>
                        </b-col>
                    </b-row>
                    <b-table
                        id="tableCdaModal"
                        ref="tableCdaModal"
                        :items="listaCdasModal"
                        :fields="fieldsCdaModal"
                        striped
                        small
                        responsive
                        :busy="configTable.load"
                        show-empty
                        hover
                        bordered
                        sort-icon-left
                        :no-local-sorting="true"
                        class="mb-0"
                        head-variant="light">
                        <div slot="table-busy" class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                        <template slot="empty">
                            <p class="my-auto">Nenhuma CDA encontrada.</p>
                        </template>
                        <template v-slot:head(selecionar)="{ item }">
                            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                        </template>
                        <template v-slot:cell(selecionar)="{ item }">
                            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selectedsCdaModal.includes(item.codPagamentoCda)" @change="toggleCheckModal($event, item)" />
                        </template>
                        <template v-slot:head(numeroCda)="{ item }">
                            Número CDA <i class="filter" :class="!isEmpty(filtros.numeroCda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número CDA', 'mascara', '', '#########', $event)"></i>
                        </template>
                        <template v-slot:head(situacaoDivida)="{ item }">
                            Situação da Dívida <i class="filter" :class="!isEmpty(filtros.situacaoDivida) || filtros.filtrarSituacaoDivida == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação da Dívida', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(situacaoDivida)="{ item }">
                            {{ item.situacaoDivida != null ? item.situacaoDivida.nome : "" }}
                        </template>
                        <template v-slot:head(status)="{ item }">
                            Status <i class="filter" :class="!isEmpty(filtros.statusCredito) || filtros.filtrarStatusCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(status)="{ item }">
                            {{ item.statusCredito != null ? item.statusCredito.nome : "" }}
                        </template>
                        <template v-slot:head(tipoCredito)="{ item }">
                            Tipo Crédito <i class="filter" :class="!isEmpty(filtros.tipoCredito) || filtros.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Crédito', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(tipoCredito)="{ item }">
                            {{ item.tipoCredito != null ? item.tipoCredito.nome : "" }}
                        </template>
                        <template v-slot:head(indAtivo)="{ item }">
                            Situação Cadastro <i class="filter" :class="!isEmpty(filtros.indAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação Cadastro', 'radio', 'Ativo,Inativo', null, $event)"></i>
                        </template>
                        <template v-slot:cell(indAtivo)="{ item }">
                            {{ (item.indAtivo == "true" || item.indAtivo == true) ? "Ativo" : "Inativo" }}
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary"
                          v-b-modal.modal-confirmar-excluir
                          :disabled="selectedsCdaModal.length <= 0"> <i class="fa fa-times"></i> Excluir</b-button>
                <b-button variant="outline-primary" @click="hide('modal-busca-cda')"> <i class="fa fa-times"></i> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
            ref="modal-confirmar-excluir"
            id="modal-confirmar-excluir"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="Confirmar exclusão"
            header-bg-variant="info"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja realmente excluir a(s) CDA(s) selecionada(s)? Essa ação não podera ser revertida.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-excluir')"> Não</b-button>
                <b-button variant="primary" @click="excluirCdasModal"> Sim</b-button>
            </template>
        </b-modal>
        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                <i class="fas fa-reply"></i> Voltar
            </b-button>
            <b-button variant="primary" class="ml-2" @click="validarSalvar()">
                <i class="far fa-save"></i> Salvar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';
    import moment from 'moment';
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";

    export default {
        components: {CompFiltroGrid, CompLoading, Multiselect},
        mixins: [ formatarMixins ],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false;
                this.consultarCdas();
            },
            perPage() {
                this.configTable.currentPage = 1;
                this.consultarCdas();
            }
        },
        data() {
            return {
                urlApi: null,
                token: null,
                messageModal: {
                    message: null,
                    variant: null
                },
                pagamento: {
                    codPagamento: null,
                    descricao: null,
                    indAtivo: true,
                    refiz: false,
                    delibSid: false,
                    dataInicialVigencia: null,
                    dataFinalVigencia: null,
                    receita: null,
                    valorMinimoParcela: null,
                    percentualHonorario: null,
                    indice: null,
                    arquivo: null,
                    numeroParcelasRescisao: null,
                    numeroDiasAtrasoParcela: null,
                    baseCalculo: 0,
                    titularReceita: null
                },
                tipoPagamento: {
                    descricao: null,
                    numeroMinimoParcelas: null,
                    numeroMaximoParcelas: null,
                    tipoPagamento: null,
                    tiposCredito: null,
                    percentualPrincipal: null,
                    percentualDescontoJuros: null,
                    percentualDescontoMulta: null,
                    valorMinimoHonorario: null,
                    valorMaximoHonorario: null,
                    indAtivo: null
                },
                cda: {
                    numeroCda: null,
                    situacaoDivida: null,
                    statusCredito: null,
                    tipoCredito: null,
                    indAtivo: true
                },
                arquivo: [],
                dados: {
                    indices: [],
                    receitas: [],
                    tiposPagamento: [],
                    tiposCredito: [],
                    situacaoDivida: [],
                    status: []
                },
                fieldsTipoPagamento: [
                    {
                        key: "selecionar",
                    },
                    {
                        key: 'descricao',
                        sortable: true,
                        label: 'Descrição.'
                    },
                    {
                        key: 'numeroMinimoParcelas',
                        sortable: true,
                        label: 'Nº Mínimo Parcelas'
                    },
                    {
                        key: 'numeroMaximoParcelas',
                        sortable: true,
                        label: 'Nº Máximo Parcelas'
                    },
                    {
                        key: 'tipoPagamento',
                        sortable: true,
                        label: 'Tipo Pagamento'
                    },
                    {
                        key: 'tiposCredito',
                        sortable: true,
                        label: 'Tipo Crédito'
                    },
                    {
                        key: 'percentualPrincipal',
                        sortable: true,
                        label: '% Desc Principal'
                    },
                    {
                        key: 'percentualDescontoMulta',
                        sortable: true,
                        label: '% Desc Multa'
                    },
                    {
                        key: 'percentualDescontoJuros',
                        sortable: true,
                        label: '% Desc Juros'
                    }
                ],
                currentPageTipoPagamento: 1,
                listaTipoPagamento: [],
                listaTipoPagamentoTemp: [],
                fieldsCda: [
                    {
                        key: "selecionar",
                    },
                    {
                        key: 'numeroCda',
                        sortable: true,
                        label: 'Número CDA.'
                    },
                    {
                        key: 'situacaoDivida',
                        sortable: true,
                        label: 'Situação da Dívida'
                    },
                    {
                        key: 'status',
                        sortable: true,
                        label: 'Status'
                    },
                    {
                        key: 'tipoCredito',
                        sortable: true,
                        label: 'Tipo Crédito'
                    },
                    {
                        key: 'indAtivo',
                        sortable: true,
                        label: 'Situação Cadastro'
                    }
                ],
                currentPageCda: 1,
                listaCdasAlterada: [],
                listaCdasExcluida: [],
                listaCdasIncluida: [],
                listaCdas: [],
                listaCdasTemp: [],
                selectedsTipoPagamento: [],
                selectedsCda: [],
                selectedsCdaModal: [],
                pesquisaTipoPagamento: false,
                indexAlterar: null,
                paymentValidations: {
                    receita: { valid: true, message: ""},
                    descricao: { valid: true, message: ""},
                    numeroParcelasRescisao: { valid: true, message: ""},
                    numeroDiasAtrasoParcela: { valid: true, message: ""},
                    percentualHonorario: { valid: true, message: ""},
                    dataInicialVigencia: { valid: true, message: ""},
                    dataFinalVigencia: { valid: true, message: ""},
                    valorMinimoParcela: { valid: true, message: ""},
                    indAtivo: { valid: true, message: ""}
                },

                paymentRangeValidations:{
                    descricao:{ valid: true, message: ""},
                    tipoPagamento: { valid: true, message: ""},
                    indAtivo: { valid: true, message: ""},
                    listaTipoPagamento: { valid: true, message: ""}
                },

                validations: {
                    parcelas: { valid: true },
                    valores: { valid: true },
                    numeroMinimoParcelas: { valid: true },
                    numeroMaximoParcelas: { valid: true },
                    percentualPrincipal: { valid: true },
                    percentualDescontoJuros: { valid: true },
                    percentualDescontoMulta: { valid: true },
                    valorMinimoHonorario: { valid: true },
                    valorMaximoHonorario: { valid: true }
                },

                cdaValidations: {
                    numeroCda: { valid: true, message: ""},
                    arquivo: {valid: true, message: ""}
                }, 
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    currentPage: 1,
                    rows: 0,
                    load: false,
                    sortField: 'cdaPagamento.numeroCda',
                    sortOrder: 'asc',
                    checkedAll: false,
                },
                listaCdasModalCompleta: [],
                listaCdasModal: [],
                fieldsCdaModal: [
                    {
                        key: "selecionar"
                    },
                    {
                        key: 'numeroCda'
                    },
                    {
                        key: 'situacaoDivida'
                    },
                    {
                        key: 'status'
                    },
                    {
                        key: 'tipoCredito'
                    },
                    {
                        key: 'indAtivo'
                    }
                ],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    codPagamento: null,
                    numeroCda: null,
                    indAtivo: null,
                    filtrarSituacaoDivida: null,
                    situacaoDivida: null,
                    filtrarStatusCredito: null,
                    statusCredito: null,
                    filtrarTipoCredito: null,
                    tipoCredito: null,
                },
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
            currentPage() {
                return this.configTable.currentPage;
            },
            perPage() {
                return this.configTable.perPage;
            },
        },
        methods: {
            async listarIndicecs() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarIndices`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.indices = response.data
                })
            },
            async listarReceitas() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarReceitas`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.receitas = response.data
                })
            },
            async listarTiposPagamento() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposPagamento`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.tiposPagamento = response.data
                })
            },
            async listarTiposCredito() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarTiposCredito`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.tiposCredito = response.data
                })
            },
            async listarSituacaoDivida() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarSituacaoDivida`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.situacaoDivida = response.data
                })
            },
            async listarStatus() {
                axios.get(`${this.urlApi}/v1/regrasPagamento/listarStatusDivida`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.status = response.data
                })
            },

            validarCompoNumerico(value, attributeValidation, message){
                if(value != null && value != '' && value <= 0) {
                    this.adicionarErroDeValidacao(attributeValidation, message);
                } else {
                   this.limparErroDeValidacao(attributeValidation);
                }
            },

            validarSalvar() {
                if(!this.verificarObrigatoriedade() || this.validationsContainsError(this.paymentValidations)){
                    window.scrollTo(0, 0);
                    return;
                }

                this.validarData(this.pagamento.dataInicialVigencia, 'Inicial', this.paymentValidations.dataInicialVigencia);
                this.validarData(this.pagamento.dataFinalVigencia, 'Final', this.paymentValidations.dataFinalVigencia);

                this.validarCompoNumerico(this.pagamento.valorMinimoParcela, this.paymentValidations.valorMinimoParcela, 'O Valor Mínimo da Parcela deve ser maior que 0!');
                
                this.validarCompoNumerico(this.pagamento.percentualHonorario, this.paymentValidations.percentualHonorario, 'O Percentual Pré-fixado de Honorários deve ser maior que 0!');
                this.validarCompoNumerico(this.pagamento.numeroParcelasRescisao, this.paymentValidations.numeroParcelasRescisao, 'O Número de Parcelas Atrasadas deve ser maior que 0!');
                this.validarCompoNumerico(this.pagamento.numeroDiasAtrasoParcela, this.paymentValidations.numeroDiasAtrasoParcela, 'O Número de Dias de Atraso deve ser maior que 0!');
               
                if(new Date(this.pagamento.dataFinalVigencia) < new Date(this.pagamento.dataInicialVigencia)) {
                    this.adicionarErroDeValidacao(this.paymentValidations.dataInicialVigencia, 'A Data Inicial não pode ser maior que a Data Final.');
                    this.adicionarErroDeValidacao(this.paymentValidations.dataFinalVigencia, 'A Data Final não pode ser menor que a Data Inicial.');
                }

                if(this.pagamento.refiz && this.pagamento.arquivo == null) {
                    this.adicionarErroDeValidacao(this.cdaValidations.arquivo, 'O carregamento do arquivo de CDAs é obrigatório para o tipo Refis.');
                }

                if(this.listaTipoPagamento.length == 0) {
                    this.adicionarErroDeValidacao(this.paymentRangeValidations.listaTipoPagamento, 'Ao menos uma faixa de pagamento deve ser informada!');
                }

                if(this.pagamento.numeroParcelasRescisao <= 0) {
                    this.validarCompoNumerico(this.pagamento.numeroParcelasRescisao, this.paymentValidations.numeroParcelasRescisao, 'Número de Parcelas Atrasadas deve ser um número positivo!');
                }

                if(this.pagamento.numeroDiasAtrasoParcela <= 0) {
                    this.validarCompoNumerico(this.pagamento.numeroDiasAtrasoParcela, this.paymentValidations.numeroDiasAtrasoParcela, 'Número de Dias de Atraso deve ser um número positivo!');
                }

                if(this.validationsContainsError(this.paymentValidations)
                    || this.validationsContainsError(this.paymentRangeValidations)
                    || this.validationsContainsError(this.cdaValidations)
                    ||this.validationsContainsError(this.validations)){
                    window.scrollTo(0, 0);
                    return;
                }
                this.$refs['modal-salvar'].show();
            },

            salvar() {
                this.$refs['modal-salvar'].hide();

                if(this.listaCdasTemp.length > 0) {
                    this.listaCdas = [];
                    this.listaCdasTemp.forEach(el => {
                        this.listaCdas.push(el);
                    });
                    this.listaCdasTemp = [];
                }
                if(this.listaTipoPagamentoTemp.length > 0) {
                    this.listaTipoPagamento = [];
                    this.listaTipoPagamentoTemp.forEach(el => {
                        this.listaTipoPagamento.push(el);
                    });
                    this.listaTipoPagamentoTemp = [];
                }

                this.pagamento.listaTipoPagamento = this.listaTipoPagamento;
                this.pagamento.listaCdas = this.listaCdas;

                let pagamentoSalvar = {
                    codPagamento: this.pagamento.codPagamento,
                    descricao: this.pagamento.descricao,
                    indAtivo: this.pagamento.indAtivo,
                    refiz: this.pagamento.refiz,
                    delibSid: this.pagamento.delibSid,
                    dataInicialVigencia: this.pagamento.dataInicialVigencia,
                    dataFinalVigencia: this.pagamento.dataFinalVigencia,
                    receita: this.pagamento.receita,
                    valorMinimoParcela: this.tratarCamposNumericos(this.pagamento.valorMinimoParcela),
                    percentualHonorario: this.tratarCamposNumericos(this.pagamento.percentualHonorario),
                    indice: this.pagamento.indice,
                    arquivo: this.pagamento.arquivo,
                    listaTipoPagamento: this.listaTipoPagamento,
                    listaCdasAdicionada: this.listaCdasIncluida,
                    listaCdasAlterada: this.listaCdasAlterada,
                    listaCdasExcluida: this.listaCdasExcluida,
                    numeroParcelasRescisao: this.pagamento.numeroParcelasRescisao,
                    numeroDiasAtrasoParcela: this.pagamento.numeroDiasAtrasoParcela,
                    baseCalculo: this.pagamento.baseCalculo,
                    titularReceita: this.pagamento.titularReceita
                };

                pagamentoSalvar.listaTipoPagamento = [];
                this.listaTipoPagamento.forEach(el => {
                    pagamentoSalvar.listaTipoPagamento.push({
                        codPagamentoTipoPagamento: el.codPagamentoTipoPagamento,
                        descricao: el.descricao,
                        numeroMinimoParcelas: this.tratarCamposNumericos(el.numeroMinimoParcelas),
                        numeroMaximoParcelas: this.tratarCamposNumericos(el.numeroMaximoParcelas),
                        tipoPagamento: el.tipoPagamento,
                        tiposCredito: el.tiposCredito,
                        percentualPrincipal: this.tratarCamposNumericos(el.percentualPrincipal),
                        percentualDescontoJuros: this.tratarCamposNumericos(el.percentualDescontoJuros),
                        percentualDescontoMulta: this.tratarCamposNumericos(el.percentualDescontoMulta),
                        valorMinimoHonorario: this.tratarCamposNumericos(el.valorMinimoHonorario),
                        valorMaximoHonorario: this.tratarCamposNumericos(el.valorMaximoHonorario),
                        indAtivo: el.indAtivo
                    });
                });

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/regrasPagamento/salvar`, pagamentoSalvar, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(this.pagamento.arquivo != null && this.pagamento.arquivo.base64 != null && this.pagamento.arquivo.base64 != "arquivo_antigo") {
                        this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!! As CDAs inclusas em lote via CSV serão feitas em segundo plano e atualizadas automaticamente.');
                    } else {
                        this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    }
                    this.$router.push({path: '/regras-pagamento'});
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            verificarObrigatoriedade() {
                if(this.validarRegraHabilitar([0, 1, 2, 3, 4, 5]) && this.verificarValorVazio(this.pagamento.baseCalculo)) {
                    return false;
                }

                this.limparValidations(this.validations);
                this.limparValidations(this.paymentValidations);
                this.limparValidations(this.paymentRangeValidations);
                this.limparValidations(this.cdaValidations);
                
                if(this.validarRegraHabilitar([0, 1, 2])){
                    this.validarCampoObrigatorio(this.pagamento.percentualHonorario, this.paymentValidations.percentualHonorario);
                }

                this.validarCampoObrigatorio(this.pagamento.receita, this.paymentValidations.receita);
                this.validarCampoObrigatorio(this.pagamento.descricao, this.paymentValidations.descricao);
                this.validarCampoObrigatorio(this.pagamento.numeroParcelasRescisao, this.paymentValidations.numeroParcelasRescisao);
                this.validarCampoObrigatorio(this.pagamento.numeroDiasAtrasoParcela, this.paymentValidations.numeroDiasAtrasoParcela);
                this.validarCampoObrigatorio(this.pagamento.dataInicialVigencia, this.paymentValidations.dataInicialVigencia);
                this.validarCampoObrigatorio(this.pagamento.dataFinalVigencia, this.paymentValidations.dataFinalVigencia);
                this.validarCampoObrigatorio(this.pagamento.valorMinimoParcela, this.paymentValidations.valorMinimoParcela);
                this.validarCampoObrigatorio(this.pagamento.indAtivo, this.paymentValidations.indAtivo);
                
                return true;
            },

            verificarValorVazio(valor) {
                return valor == null || valor === "";
            },

            adicionarTipoPagamento() {
                this.limparValidations(this.paymentRangeValidations);
                this.validarCampoObrigatorio(this.tipoPagamento.descricao, this.paymentRangeValidations.descricao);
                this.validarCampoObrigatorio(this.tipoPagamento.tipoPagamento, this.paymentRangeValidations.tipoPagamento);
                this.validarCampoObrigatorio(this.tipoPagamento.indAtivo, this.paymentRangeValidations.indAtivo);

                if(this.validationsContainsError(this.paymentRangeValidations)){
                    this.inSave = false;
                    return;
                }

                let valid = true;
                if(!this.isEmpty(this.tipoPagamento.numeroMinimoParcelas) && this.tipoPagamento.numeroMinimoParcelas <= 0) {
                    this.validations.numeroMinimoParcelas.valid = false;
                    valid = false;
                } else {
                    this.validations.numeroMinimoParcelas.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.numeroMaximoParcelas) && this.tipoPagamento.numeroMaximoParcelas <= 0) {
                    this.validations.numeroMaximoParcelas.valid = false;
                    valid = false;
                } else {
                    this.validations.numeroMaximoParcelas.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.percentualPrincipal) && this.tipoPagamento.percentualPrincipal <= 0) {
                    this.validations.percentualPrincipal.valid = false;
                    valid = false;
                } else {
                    this.validations.percentualPrincipal.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.percentualDescontoJuros) && this.tipoPagamento.percentualDescontoJuros <= 0) {
                    this.validations.percentualDescontoJuros.valid = false;
                    valid = false;
                } else {
                    this.validations.percentualDescontoJuros.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.percentualDescontoMulta) && this.tipoPagamento.percentualDescontoMulta <= 0) {
                    this.validations.percentualDescontoMulta.valid = false;
                    valid = false;
                } else {
                    this.validations.percentualDescontoMulta.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.valorMinimoHonorario) && this.tipoPagamento.valorMinimoHonorario <= 0) {
                    this.validations.valorMinimoHonorario.valid = false;
                    valid = false;
                } else {
                    this.validations.valorMinimoHonorario.valid = true;
                }
                if(!this.isEmpty(this.tipoPagamento.valorMaximoHonorario) && this.tipoPagamento.valorMaximoHonorario <= 0) {
                    this.validations.valorMaximoHonorario.valid = false;
                    valid = false;
                } else {
                    this.validations.valorMaximoHonorario.valid = true;
                }

                if(!valid) {
                    return;
                }

                if(this.tipoPagamento.tipoPagamento.id == 1) {
                    if (parseInt(this.tipoPagamento.numeroMinimoParcelas) > parseInt(this.tipoPagamento.numeroMaximoParcelas)) {
                        this.validations.parcelas.valid = false;
                        valid = false;
                    } else {
                        this.validations.parcelas.valid = true;
                    }

                    if (parseFloat(this.tratarCamposNumericos(this.tipoPagamento.valorMinimoHonorario)) > parseFloat(this.tratarCamposNumericos(this.tipoPagamento.valorMaximoHonorario))) {
                        this.validations.valores.valid = false;
                        valid = false;
                    } else {
                        this.validations.valores.valid = true;
                    }
                } else {
                    this.tipoPagamento.numeroMinimoParcelas = null;
                    this.tipoPagamento.numeroMaximoParcelas = null;
                    this.tipoPagamento.valorMinimoHonorario = null;
                    this.tipoPagamento.valorMaximoHonorario = null;
                }

                if(!valid) {
                    return;
                }

                if(this.listaTipoPagamentoTemp.length > 0) {
                    this.listaTipoPagamento = [];
                    this.listaTipoPagamentoTemp.forEach(el => {
                        this.listaTipoPagamento.push(el);
                    });
                    this.listaTipoPagamentoTemp = [];
                }

                if(this.indexAlterar != null) {
                    this.listaTipoPagamento[this.indexAlterar] = this.tipoPagamento;
                } else {
                    this.listaTipoPagamento.push(this.tipoPagamento);
                }

                this.selectedsTipoPagamento = [];
                this.indexAlterar = null;

                this.$refs.tableTipoPagamento.refresh();

                this.tipoPagamento = {
                    codPagamentoTipoPagamento: null,
                    descricao: null,
                    numeroMinimoParcelas: null,
                    numeroMaximoParcelas: null,
                    tipoPagamento: null,
                    tiposCredito: null,
                    percentualPrincipal: null,
                    percentualDescontoJuros: null,
                    percentualDescontoMulta: null,
                    valorMinimoHonorario: null,
                    valorMaximoHonorario: null,
                    indAtivo: (this.pagamento.codPagamento == null ? true : null)
                };
            },

            alterar() {
                if(this.listaTipoPagamentoTemp.length > 0) {
                    this.listaTipoPagamento = [];
                    this.listaTipoPagamentoTemp.forEach(el => {
                        this.listaTipoPagamento.push(el);
                    });
                    this.listaTipoPagamentoTemp = [];
                }

                this.indexAlterar = this.listaTipoPagamento.indexOf(this.selectedsTipoPagamento[0]);
                this.tipoPagamento = {
                    ... this.listaTipoPagamento[this.indexAlterar]
                };
            },

            excluir() {
                if(this.listaTipoPagamentoTemp.length > 0) {
                    this.listaTipoPagamento = [];
                    this.listaTipoPagamentoTemp.forEach(el => {
                        this.listaTipoPagamento.push(el);
                    });
                    this.listaTipoPagamentoTemp = [];
                }

                const index = this.listaTipoPagamento.indexOf(this.selectedsTipoPagamento[0]);
                this.listaTipoPagamento.splice(index, 1);
                this.selectedsTipoPagamento = [];
                this.tipoPagamento = {
                    codPagamentoTipoPagamento: null,
                    descricao: null,
                    numeroMinimoParcelas: null,
                    numeroMaximoParcelas: null,
                    tipoPagamento: null,
                    tiposCredito: null,
                    percentualPrincipal: null,
                    percentualDescontoJuros: null,
                    percentualDescontoMulta: null,
                    valorMinimoHonorario: null,
                    valorMaximoHonorario: null,
                    indAtivo: null
                };
            },

            pesquisar() {
                if(this.listaTipoPagamentoTemp.length == 0) {
                    this.listaTipoPagamento.forEach(el => {
                        this.listaTipoPagamentoTemp.push(el);
                    });
                }

                this.pesquisaTipoPagamento = true;
                this.listaTipoPagamento = [];
                this.listaTipoPagamentoTemp.forEach(el => {
                    if ((this.verificarValorVazio(this.tipoPagamento.descricao) || el.descricao == this.tipoPagamento.descricao) &&
                        (this.verificarValorVazio(this.tipoPagamento.numeroMinimoParcelas) || el.numeroMinimoParcelas == this.tipoPagamento.numeroMinimoParcelas) &&
                        (this.verificarValorVazio(this.tipoPagamento.numeroMaximoParcelas) || el.numeroMaximoParcelas == this.tipoPagamento.numeroMaximoParcelas) &&
                        (this.verificarValorVazio(this.tipoPagamento.tipoPagamento) || el.tipoPagamento == this.tipoPagamento.tipoPagamento) &&
                        (this.verificarValorVazio(this.tipoPagamento.tiposCredito) || el.tiposCredito == this.tipoPagamento.tiposCredito) &&
                        (this.verificarValorVazio(this.tipoPagamento.percentualPrincipal) || el.percentualPrincipal == this.tipoPagamento.percentualPrincipal) &&
                        (this.verificarValorVazio(this.tipoPagamento.percentualDescontoJuros) || el.percentualDescontoJuros == this.tipoPagamento.percentualDescontoJuros) &&
                        (this.verificarValorVazio(this.tipoPagamento.percentualDescontoMulta) || el.percentualDescontoMulta == this.tipoPagamento.percentualDescontoMulta) &&
                        (this.verificarValorVazio(this.tipoPagamento.valorMinimoHonorario) || el.valorMinimoHonorario == this.tipoPagamento.valorMinimoHonorario) &&
                        (this.verificarValorVazio(this.tipoPagamento.valorMaximoHonorario) || el.valorMaximoHonorario == this.tipoPagamento.valorMaximoHonorario) &&
                        (this.verificarValorVazio(this.tipoPagamento.indAtivo) || el.indAtivo.toString() == this.tipoPagamento.indAtivo.toString())) {
                        this.listaTipoPagamento.push(el);
                        this.$refs.tableTipoPagamento.refresh();
                    }
                });
            },

            toggleCheck(checked, item) {
                if(checked) {
                    this.selectedsTipoPagamento.push(item);
                } else {
                    const index = this.selectedsTipoPagamento.indexOf(item);
                    this.selectedsTipoPagamento.splice(index, 1);
                }

            },

            limparCda(){
                 this.cda = {
                        codPagamentoCda: null,
                        numeroCda: null,
                        situacaoDivida: null,
                        statusCredito: null,
                        tipoCredito: null,
                        indAtivo: true
                    };
            },

            adicionarCda() {
                this.limparValidations(this.cdaValidations);
                this.validarCampoObrigatorio(this.cda.numeroCda, this.cdaValidations.numeroCda);

                if(this.validationsContainsError(this.cdaValidations)){
                    return;
                }
                
                if(this.listaCdasTemp.length > 0) {
                    this.listaCdas = [];
                    this.listaCdasTemp.forEach(el => {
                        this.listaCdas.push(el);
                    });
                    this.listaCdasTemp = [];
                }

              
                for(var i = 0; i < this.listaCdas.length; i++) {
                    if(this.listaCdas[i].numeroCda == this.cda.numeroCda) {
                        this.adicionarErroDeValidacao(this.cdaValidations.numeroCda, "CDA já incluída!");
                        this.inSave = false;
                        return;
                    }
                }
            
                for(var i = 0; i < this.listaCdasModalCompleta.length; i++) {
                    if(this.listaCdasModalCompleta[i].numeroCda == this.cda.numeroCda) {
                        this.adicionarErroDeValidacao(this.cdaValidations.numeroCda, "CDA já incluída!");
                        this.inSave = false;
                        return;
                    }
                }
              
                this.$refs.loading.showLoading();				
                axios.get(`${this.urlApi}/v1/regrasPagamento/consultarSituacaoCda/${this.cda.numeroCda}`, {
                headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                }
                }).then(response => {
                    if(response.data.mensagemDeErro != null){
                        this.adicionarErroDeValidacao(this.cdaValidations.numeroCda, response.data.mensagemDeErro);
                        return;
                    }

                    let cdaResponse = response.data.mainframeDaean026DTO;
                    this.cda.situacaoDivida = this.dados.situacaoDivida.find(situacaoDivida => situacaoDivida.id == cdaResponse.codSituacao
                        || situacaoDivida.nome.toLowerCase() == cdaResponse.descSituacao.toLowerCase());

                    this.cda.statusCredito = this.dados.status.find(status => status.id == cdaResponse.codStatus 
                        || status.nome.toLowerCase() == cdaResponse.descStatus.toLowerCase);

                    this.cda.tipoCredito = this.dados.tiposCredito.find(tipoCredito => tipoCredito.id == cdaResponse.codTipo
                        || tipoCredito.nome.toLowerCase() == cdaResponse.descTipo.toLowerCase());
                   
                    this.listaCdas.push(this.cda);
                    this.listaCdasIncluida.push(this.cda);

                    this.selectedsCda = [];
                    this.$refs.tableCda.refresh();

                   this.limparCda();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },

            excluirCda() {
                if(this.listaCdasTemp.length > 0) {
                    this.listaCdas = [];
                    this.listaCdasTemp.forEach(el => {
                        this.listaCdas.push(el);
                    });
                    this.listaCdasTemp = [];
                }

                if(this.selectedsCda[0].codPagamentoCda != null) {
                    this.listaCdasExcluida.push(this.selectedsCda[0]);
                }

                const index = this.listaCdas.indexOf(this.selectedsCda[0]);

                this.listaCdas.splice(index, 1);
                this.selectedsCda = [];
                this.cda = {
                    codPagamentoCda: null,
                    numeroCda: null,
                    situacaoDivida: null,
                    statusCredito: null,
                    tipoCredito: null,
                    indAtivo: null
                };
            },

            toggleCheckCda(checked, item) {
                if(checked) {
                    this.selectedsCda.push(item);
                } else {
                    const index = this.selectedsCda.indexOf(item);
                    this.selectedsCda.splice(index, 1);
                }

            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/regras-pagamento'});
            },

            uploadFile() {
                var arquivosConvertidos = [];
                var file = this.arquivo[0].file;
                var reader = new FileReader();
                reader.onload = function () {
                    var arquivoFormatado = {
                        nomeArquivo: file.name,
                        base64: reader.result
                    };

                    arquivosConvertidos.push(arquivoFormatado);
                };
                reader.readAsDataURL(file);
                reader.onloadend = () => this.executeUpload(arquivosConvertidos);
            },

            async executeUpload(arquivosConvertidos){
                this.pagamento.arquivo = arquivosConvertidos[0];

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/regrasPagamento/carregarCdaLote`, arquivosConvertidos[0], {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data == null || !response.data) {
                        this.pagamento.arquivo = null;
                        this.$refs['modal-upload'].show();
                    } else {
                        this.$refs['modal-upload-sucesso'].show();
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            async obterPagamento(codPagamento) {
                this.$refs.loading.showLoading();
                await axios.get(`${this.urlApi}/v1/regrasPagamento/obter/` + codPagamento, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.pagamento = {
                        codPagamento: response.data.codPagamento,
                        descricao: response.data.descricao,
                        indAtivo: response.data.indAtivo,
                        refiz: response.data.refiz,
                        delibSid: response.data.delibSid,
                        dataInicialVigencia: response.data.dataInicialVigenciaString,
                        dataFinalVigencia: response.data.dataFinalVigenciaString,
                        receita: response.data.receita,
                        valorMinimoParcela: this.formatarMonetarioExibir(response.data.valorMinimoParcela, 3, 2),
                        percentualHonorario: this.formatarMonetarioExibir(response.data.percentualHonorario, 3, 2),
                        indice: response.data.indice,
                        baseCalculo: response.data.baseCalculo,
                        arquivo: response.data.arquivo,
                        numeroParcelasRescisao: response.data.numeroParcelasRescisao,
                        numeroDiasAtrasoParcela: response.data.numeroDiasAtrasoParcela,
                        titularReceita: response.data.titularReceita,
                    };

                    this.listaTipoPagamento = response.data.listaTipoPagamento;
                    this.listaTipoPagamento.forEach(el => {
                        el.numeroMinimoParcelas = this.formatarDecimalPositivo(el.numeroMinimoParcelas, 5, 0);
                        el.numeroMaximoParcelas = this.formatarDecimalPositivo(el.numeroMaximoParcelas, 5, 0);
                        el.percentualPrincipal = this.formatarMonetarioExibir(el.percentualPrincipal, 3, 2);
                        el.percentualDescontoJuros = this.formatarMonetarioExibir(el.percentualDescontoJuros, 3, 2);
                        el.percentualDescontoMulta = this.formatarMonetarioExibir(el.percentualDescontoMulta, 3, 2);
                        el.valorMinimoHonorario = this.formatarMonetarioExibir(el.valorMinimoHonorario, 3, 2);
                        el.valorMaximoHonorario = this.formatarMonetarioExibir(el.valorMaximoHonorario, 3, 2);
                    });

                    this.consultarCdasTodas();
                }).catch((error) => {
                    this.exibirErro(error);
                    this.$refs.loading.hideLoading();
                })
            },

            validarData(value, data, attributeValidation) {
                if(!moment(value, "YYYY-M-D", true).isValid()) {
                    this.adicionarErroDeValidacao(attributeValidation, "Data " + data + " inválida!")
                    return false;
                }else{
                     this.limparErroDeValidacao(attributeValidation);
                    return true;
                }
            },

            alterarTipoPagamento() {
                if(this.tipoPagamento.tipoPagamento.id == 0) {
                    this.tipoPagamento.numeroMinimoParcelas = null;
                    this.tipoPagamento.numeroMaximoParcelas = null;
                    this.tipoPagamento.valorMinimoHonorario = null;
                    this.tipoPagamento.valorMaximoHonorario = null;
                }
            },

            validarRegraHabilitar(tiposValidacao) {
                if(this.pagamento.receita != null) {
                    if(this.pagamento.receita.id == 1) {
                        if(!this.pagamento.refiz) {
                            return tiposValidacao.includes(0);
                        }

                        return this.pagamento.baseCalculo == 2 || this.pagamento.baseCalculo == 3 ? tiposValidacao.includes(2) : tiposValidacao.includes(1);
                    }

                    if(this.pagamento.receita.id == 2) {
                        if(!this.pagamento.refiz) {
                            return tiposValidacao.includes(3);
                        }

                        return this.pagamento.baseCalculo == 2 || this.pagamento.baseCalculo == 3 ? tiposValidacao.includes(5) : tiposValidacao.includes(4);
                    }

                    return tiposValidacao.includes(6);
                }

                return false;
            },

            async consultarCdas() {
                this.$store.commit("setMessages", {});

                let perPageStr = `&perPage=${this.configTable.perPage}`;

                this.filtros.codPagamento = this.pagamento.codPagamento;

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/regrasPagamento/consultarCdaPagamento?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`,
                    this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.listaCdasModal = response.data.resultado;
                    this.configTable.rows = response.data.rows;
                    this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            async consultarCdasTodas() {
                this.$store.commit("setMessages", {});

                this.filtros.codPagamento = this.pagamento.codPagamento;

                axios.post(`${this.urlApi}/v1/regrasPagamento/consultarCdaPagamento`,
                    this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.listaCdasModalCompleta = response.data.resultado;
                }).catch((error) => {
                    this.exibirErro(error);
                    this.$refs.loading.hideLoading();
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },

            toggleAll(checked) {
                if(checked) {
                    this.listaCdasModal.forEach(el => {
                        if(!this.selectedsCdaModal.includes(el.codPagamentoCda)) {
                            this.selectedsCdaModal.push(el.codPagamentoCda);
                        }
                    })
                } else {
                    this.listaCdasModal.forEach(el => {
                        if(this.selectedsCdaModal.includes(el.codPagamentoCda)) {
                            const index = this.selectedsCdaModal.indexOf(el.codPagamentoCda);
                            this.selectedsCdaModal.splice(index, 1);
                        }
                    })
                }
            },
            toggleCheckModal(checked, item) {
                if(checked) {
                    this.selectedsCdaModal.push(item.codPagamentoCda);
                } else {
                    const index = this.selectedsCdaModal.indexOf(item.codPagamentoCda);
                    this.selectedsCdaModal.splice(index, 1);
                    this.configTable.checkedAll = false;
                }

            },

            openFilter(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Número CDA') {
                        this.filtro.campoMascara = this.filtros.numeroCda;
                    } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                        this.filtro.filtrarEm = this.filtros.filtrarSituacaoDivida;
                        this.filtro.campoTexto = this.filtros.situacaoDivida;
                    } else if(this.filtro.campoFiltro == 'Status') {
                        this.filtro.filtrarEm = this.filtros.filtrarStatusCredito;
                        this.filtro.campoTexto = this.filtros.statusCredito;
                    } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                        this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                        this.filtro.campoTexto = this.filtros.tipoCredito;
                    } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                        this.filtro.campoRadio = this.filtros.indAtivo;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event, true, 380, 95);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Número CDA') {
                    this.filtros.numeroCda = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                    this.filtros.filtrarSituacaoDivida = this.filtro.filtrarEm;
                    this.filtros.situacaoDivida = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Status') {
                    this.filtros.filtrarStatusCredito = this.filtro.filtrarEm;
                    this.filtros.statusCredito = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                    this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                    this.filtros.tipoCredito = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                    this.filtros.indAtivo = this.filtro.campoRadio;
                }

                this.consultarCdas();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Número CDA') {
                    this.configTable.sortField = 'cdaPagamento.numeroCda'
                } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                    this.configTable.sortField = 'situacaoDivida'
                } else if(this.filtro.campoFiltro == 'Status') {
                    this.configTable.sortField = 'status'
                } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                    this.configTable.sortField = 'cdaPagamento.tipoCredito.descricao'
                } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                    this.configTable.sortField = 'indAtivo'
                }

                this.configTable.sortOrder = order;

                this.consultarCdas();
            },
            excluirCdasModal() {
                this.hideModal('modal-confirmar-excluir');
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/regrasPagamento/excluirCdaPagamento`,
                    this.selectedsCdaModal, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                }).then(response => {
                    this.selectedsCdaModal = [];
                    this.configTable.checkedAll = false;
                    this.messageModal = {
                        message: 'CDA(s) excluída(s) com sucesso.',
                        variant: 'success'
                    };
                    this.consultarCdas();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                    this.$refs.loading.hideLoading();
                })
            },
            abrirModalCdas() {
                this.messageModal = {
                    message: null,
                    variant: null
                };
                this.selectedsCdaModal = [];
                this.configTable.checkedAll = false;
                this.configTable.currentPage = 1;
                this.filtros = {
                    codPagamento: null,
                    numeroCda: null,
                    indAtivo: null,
                    filtrarSituacaoDivida: null,
                    situacaoDivida: null,
                    filtrarStatusCredito: null,
                    statusCredito: null,
                    filtrarTipoCredito: null,
                    tipoCredito: null
                };
                this.consultarCdas();
            },
            
            acaoDaAlteracaoDaReceita(){
                this.pagamento.refiz = null;
                if(!this.validarRegraHabilitar([0, 1, 2])){
                    this.limparErroDeValidacao(this.paymentValidations.percentualHonorario);
                }
            }

        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
            let pagamentoEditado = this.$store.getters.getPagamento;
            if(pagamentoEditado) {
                this.$store.commit('setPagamento', null);
                this.obterPagamento(pagamentoEditado);
            } else {
                this.tipoPagamento.indAtivo = true;
                this.cda.indAtivo = true;
            }

            this.listarIndicecs();
            this.listarReceitas();
            this.listarTiposPagamento();
            this.listarTiposCredito();
            this.listarSituacaoDivida();
            this.listarStatus();
        }
    }
</script>
